
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web/frequently-asked-questions/[params]",
      function () {
        return require("private-next-pages/web/frequently-asked-questions/[params]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/web/frequently-asked-questions/[params]"])
      });
    }
  